"use client";

import {
  Box,
  Button,
  ButtonGroup,
  Container,
  Link,
  Stack,
} from "@chakra-ui/react";
import React from "react";
import { ChakraMarkdown } from "@/components/Markdown";

type CallToActionBlockProps = {
  content: string;
  buttons: {
    label: string;
    url: string;
    newTab?: boolean | null;
  }[];
};

export function CallToActionBlock({
  content,
  buttons,
}: CallToActionBlockProps) {
  return (
    <Container
      borderRadius="2xl"
      p={{ base: 6, md: 10 }}
      shadow="md"
      bg="bg"
      fluid
    >
      <Stack direction="column">
        <Box color="fg.muted" fontSize="lg">
          <ChakraMarkdown>{content}</ChakraMarkdown>
        </Box>

        <Stack direction={{ base: "column", sm: "row" }}>
          <ButtonGroup colorScheme="blue" size="lg" flexWrap="wrap">
            {buttons.map((button, i) => (
              <Button key={i} variant={i === 0 ? "solid" : "outline"} asChild>
                <Link
                  href={button.url}
                  target={button.newTab ? "_blank" : undefined}
                  rel={button.newTab ? "noopener noreferrer" : undefined}
                >
                  {button.label}
                </Link>
              </Button>
            ))}
          </ButtonGroup>
        </Stack>
      </Stack>
    </Container>
  );
}
